export const userSelect = (state) => state.auth.user;
export const homeScreenStatSelect = (state) => state.finance.homescreenstat;
export const allEscrowSelect = (state) => state.escrow.allescrow;
export const allDepositSelect = (state) => state.deposit.depositdata;
export const allWithdrawalSelect = (state) => state.withdrawal.withdrawaldata;
export const allRemoteSettingsSelect = (state) => state.settings.settings;
export const allFXSelect = (state) => state.fx.fxhead;
